"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ReplySVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var ReplySVG = function ReplySVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M26.561,14.85A12.249,12.249,0,0,0,18,12H5.414l6.293-6.293a1,1,0,1,0-1.414-1.414l-8,8a1,1,0,0,0,0,1.414l8,8a1,1,0,0,0,1.414-1.414L5.414,14l12.669,0c.046,0,4.26-.313,7.139,2.339C27.065,18.035,28,20.614,28,24v3a1,1,0,0,0,2,0V24C30,20.022,28.843,16.944,26.561,14.85Z"
  }));
};
exports.ReplySVG = ReplySVG;
ReplySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ReplySVG);
exports.default = _default;